import Vue from 'vue'
import App from './App.vue'
import router from './router'

import plugins from './plugins' // plugins
Vue.use(plugins)

// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
import ImagerUplaod from "@/components/ImageUpload"
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";


Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree

Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination_rouyi', Pagination)
Vue.component('ImagePreview', ImagePreview)
Vue.component('ImagerUplaod', ImagerUplaod)


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


// 引入插件和语言包
import {i18n} from './il8n/index';
// 从localStorage获取用户语言偏好
const savedLanguage = localStorage.getItem('userLanguage') || 'zh';
i18n.locale = savedLanguage;
Vue.use(i18n);

// import VueLazyload from 'vue-lazyload'

// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'http://www.lozky.com/file/loading.gif',
//   loading: 'http://www.lozky.com/file/loading.gif',
//   attempt: 3
// })

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

